export default __webpack_public_path__ + "static/media/renzo.36b5ab52.jpg";